import React from 'react';
import { Modal } from 'carbon-components-react';
import { phoneNumberFormatter } from 'utilities/validation';

const ReferralContactModal = ({
  referral,
  showReferralContactModal,
  setShowReferralContactModal
}: {
  referral: any;
  showReferralContactModal: boolean;
  setShowReferralContactModal: (show: boolean) => void;
}) => {
  return (
    <Modal
      open={showReferralContactModal}
      passiveModal
      modalHeading="Contact"
      onRequestClose={() => setShowReferralContactModal(false)}
      className="mobile-get-plans-refferal-contact-modal"
    >
      <div className="mobile-view-referral-contact-content">
        {referral.contactPhoneNumber && (
          <a href={`tel:${referral.contactPhoneNumber}`} target="_parent">
            <div className="mobile-view-contact-row mobile-view-contact-row-border">
              <div>PHONE (GENERAL)</div>
              <div>
                {phoneNumberFormatter({
                  phoneNumber: referral.contactPhoneNumber
                }).getNationalNumberFormat()}
              </div>
            </div>
          </a>
        )}
        {referral.contactEmail && (
          <a href={`mailto:${referral.contactEmail}`} target="_parent">
            <div className="mobile-view-contact-row mobile-view-contact-row-border">
              <div>EMAIL (GENERAL)</div>
              <div className="mobile-view-contact-email">
                {referral.contactEmail}
              </div>
            </div>
          </a>
        )}
        {referral.contactUrl && (
          <a
            href={referral.contactUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            <div className="mobile-view-contact-row mobile-view-contact-row-border">
              <div>WEB (GENERAL)</div>
              <div>Opens in a new tab</div>
            </div>
          </a>
        )}
        {referral.contactEmergencyPhone && (
          <a href={`tel:${referral.contactEmergencyPhone}`} target="_parent">
            <div className="mobile-view-contact-row mobile-view-contact-emergency">
              <div>EMERGENCY</div>
              <div>
                {phoneNumberFormatter({
                  phoneNumber: referral.contactEmergencyPhone
                }).getNationalNumberFormat()}
              </div>
            </div>
          </a>
        )}
      </div>
    </Modal>
  );
};

export default ReferralContactModal;
